import { render, staticRenderFns } from "./HomePageTeachOrPartner.vue?vue&type=template&id=ba030802&scoped=true"
import script from "./HomePageTeachOrPartner.vue?vue&type=script&lang=js"
export * from "./HomePageTeachOrPartner.vue?vue&type=script&lang=js"
import style0 from "./HomePageTeachOrPartner.vue?vue&type=style&index=0&id=ba030802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba030802",
  null
  
)

export default component.exports